const countryCurrencies: Record<string, string> = {
  NG: "NGN",
  GH: "GHS",
  KE: "KES",
};
const symbols: Record<string, string> = {
  NGN: "₦",
  GHS: "₵",
  KES: "KSh",
  USD: "$",
};

export const getUserCurrency = (user?: { country?: string } | null) =>
  countryCurrencies[
    String(user?.country ?? "NG")
      .trim()
      .toUpperCase()
  ] ?? countryCurrencies.NG;

export const currencySymbolFull = (value: string) => {
  const code = value.toUpperCase();
  return code === "NAIRA" ? "NGN" : code;
};

const currency = (value: string) => {
  const code = currencySymbolFull(value);
  return symbols[code] ?? code;
};

export const moneyFormat = (
  value: number | string,
  showDecimal: boolean = true,
) =>
  Number(value)
    .toFixed(showDecimal ? 2 : 0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// .replace(/\d(?=(\d{3})+\.)/g, '$&,');

export const cryptoFormat = (value: number | string) => {
  let val =
    String(value)?.split(".")[1]?.length >= 8
      ? Number(value).toFixed(8)
      : String(value);

  return val.replace(/\.\d+|\d(?=(?:\d{3})+(?!\d))/g, function (a) {
    return a.length === 1 ? a + "," : a;
  });
};

export default currency;
